// CAPABILITY: Persist chat sidebar open/closed state per browser.

const VISIBILITY_STORAGE_KEY = "vdopage_chat_open_v1";

export function getChatOpen(defaultOpen = true) {
  try {
    const stored = window.localStorage.getItem(VISIBILITY_STORAGE_KEY);
    if (stored === null) return defaultOpen;
    return stored === "1";
  } catch (_error) {
    return defaultOpen;
  }
}

export function setChatOpen(isOpen) {
  try {
    window.localStorage.setItem(VISIBILITY_STORAGE_KEY, isOpen ? "1" : "0");
  } catch (_error) {
    /* ignore */
  }
}

export { VISIBILITY_STORAGE_KEY };
